import React, { useEffect, useState } from "react";
import { IconBoxDevice } from "../../components/Icons/Icons";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import styles from "./PageProjectDetail.module.css";
import { numFormatter } from "../../helpers/functions";

export const SimulateTab = () => {
  const [montoInversion, setMontoInversion] = useState("");
  const [totalUnidades, setTotalUnidades] = useState("");
  const [valorUnidad, setValorUnidad] = useState("");
  const [plazoInversion, setPlazoInversion] = useState("");
  const [ganancia, setGanancia] = useState("");
  const [unidades, setUnidades] = useState(0);

  useEffect(() => {
    if (montoInversion && valorUnidad) {
      const calculoUnidades = montoInversion / valorUnidad;
      setUnidades(calculoUnidades.toFixed(0));
    }
  }, [montoInversion, valorUnidad]);

  useEffect(() => {
    if (plazoInversion) {
      let minGanancia, maxGanancia;
      switch (plazoInversion) {
        case "6 meses":
          minGanancia = (montoInversion * 0.095) / 2;
          maxGanancia = (montoInversion * 0.115) / 2;
          break;
        case "12 meses":
          minGanancia = montoInversion * 0.095;
          maxGanancia = montoInversion * 0.115;
          break;
        case "2 años":
          minGanancia = montoInversion * 0.095 * 2;
          maxGanancia = montoInversion * 0.115 * 2;
          break;
        case "3 años":
          minGanancia = montoInversion * 0.095 * 3;
          maxGanancia = montoInversion * 0.115 * 3;
          break;
        case "5 años":
          minGanancia = montoInversion * 0.095 * 5;
          maxGanancia = montoInversion * 0.115 * 5;
          break;
        case "10 años":
          minGanancia = montoInversion * 0.095 * 10;
          maxGanancia = montoInversion * 0.115 * 10;
          break;
        default:
          minGanancia = 0;
          maxGanancia = 0;
      }
      setGanancia(
        `${numFormatter({ num: minGanancia })} - ${numFormatter({
          num: maxGanancia,
        })}`
      );
    }
  }, [montoInversion, plazoInversion]);

  return (
    <div style={{ padding: "10px 0" }}>
      <div className="page-security-head" style={{ padding: "5px 0px 20px" }}>
        <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center" }}>
          <IconBoxDevice
            colorIcon={"#1b4ec1"}
            height={"20px"}
            width={"25px"}
          />
          <span style={{ marginLeft: "10px" }}>Simula tu inversión</span>
        </div>
        <p style={{ fontSize: "14px", color: "#6c757d", marginTop: "10px", marginBottom: "0" }}>
          Calcula el rendimiento potencial de tu inversión según el monto y plazo deseado
        </p>
      </div>

      <div style={{ 
        backgroundColor: "#f8f9fa", 
        padding: "20px", 
        borderRadius: "8px",
        marginBottom: "20px"
      }}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="monto-inversion">
                Monto de inversión
              </InputLabel>
              <OutlinedInput
                id="monto-inversion"
                type="number"
                value={montoInversion}
                onChange={(e) => setMontoInversion(e.target.value)}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                label="Monto de inversión"
                placeholder="100000"
              />
            </FormControl>
            <small style={{ color: "#6c757d", fontSize: "12px", display: "block", marginTop: "5px" }}>
              Ingresa el monto que deseas invertir
            </small>
          </div>

          <div className="col-md-6 mb-3">
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="valor-unidad">
                Valor por unidad
              </InputLabel>
              <OutlinedInput
                id="valor-unidad"
                type="number"
                onChange={(e) => setValorUnidad(e.target.value)}
                value={valorUnidad}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                label="Valor por unidad"
                placeholder="1000"
              />
            </FormControl>
            <small style={{ color: "#6c757d", fontSize: "12px", display: "block", marginTop: "5px" }}>
              Valor unitario del fideicomiso
            </small>
          </div>

          <div className="col-md-6 mb-3">
            <FormControl fullWidth variant="outlined">
              <InputLabel>Plazo de inversión</InputLabel>
              <Select
                value={plazoInversion}
                onChange={(e) => setPlazoInversion(e.target.value)}
                label="Plazo de inversión"
              >
                <MenuItem value="6 meses">6 meses</MenuItem>
                <MenuItem value="12 meses">12 meses (1 año)</MenuItem>
                <MenuItem value="2 años">2 años</MenuItem>
                <MenuItem value="3 años">3 años</MenuItem>
                <MenuItem value="5 años">5 años</MenuItem>
                <MenuItem value="10 años">10 años</MenuItem>
              </Select>
            </FormControl>
            <small style={{ color: "#6c757d", fontSize: "12px", display: "block", marginTop: "5px" }}>
              Tiempo que mantendrás tu inversión
            </small>
          </div>

          <div className="col-md-6 mb-3">
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="total-unidades">
                Unidades a adquirir
              </InputLabel>
              <OutlinedInput
                id="total-unidades"
                type="text"
                value={unidades}
                readOnly
                endAdornment={
                  <InputAdornment position="end">unidades</InputAdornment>
                }
                label="Unidades a adquirir"
                sx={{ backgroundColor: "#e9ecef" }}
              />
            </FormControl>
            <small style={{ color: "#6c757d", fontSize: "12px", display: "block", marginTop: "5px" }}>
              Calculado automáticamente
            </small>
          </div>
        </div>
      </div>

      {ganancia && (
        <div style={{
          background: "linear-gradient(135deg, #1b4ec1 0%, #2563eb 100%)",
          padding: "25px",
          borderRadius: "12px",
          color: "white",
          marginBottom: "20px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
        }}>
          <div style={{ textAlign: "center" }}>
            <p style={{ 
              margin: "0 0 10px 0", 
              fontSize: "16px", 
              fontWeight: "500",
              opacity: "0.95"
            }}>
              Ganancia proyectada
            </p>
            <p style={{ 
              margin: "0 0 10px 0", 
              fontSize: "32px", 
              fontWeight: "700",
              letterSpacing: "-0.5px"
            }}>
              ${ganancia}
            </p>
            <p style={{ 
              margin: "0", 
              fontSize: "13px",
              opacity: "0.9"
            }}>
              Rendimiento estimado entre 9.5% - 11.5% anual
            </p>
          </div>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button 
          className="btn _btn-primary font-14"
          style={{ 
            padding: "12px 40px",
            fontSize: "16px",
            fontWeight: "600"
          }}
          disabled={!montoInversion || !valorUnidad || !plazoInversion}
        >
          Quiero invertir
        </button>
        <p style={{ 
          fontSize: "12px", 
          color: "#6c757d", 
          marginTop: "15px",
          fontStyle: "italic"
        }}>
          * Los rendimientos proyectados son estimaciones y no constituyen una garantía
        </p>
      </div>
    </div>
  );
};
